import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'

function UserInfoStats({ username, totals = {
  modelCount: null,
  projectsDone: null,
  projectsActive: null,
  modelViews: null,
} }) {
  return (
    <div className="user-data__counters-row">
      <Tooltip
        wrapperClassName="user-data__tooltip-wrapper"
        id={`model-count__tooltip-${username}`}
        content="Models count"
      >
        <span className="user-data__counter-wrapper">
          <Icon type={['far', 'cube']} className="user-data__counters-icon" notSpaced />
          <span className="heading-14">
            {numeral(totals.modelCount).format('0,0')}
          </span>
        </span>
      </Tooltip>
      <Tooltip
        wrapperClassName="user-data__tooltip-wrapper"
        id={`project-count__tooltip-${username}`}
        content={`Completed 3D Projects. Currently working on ${totals.projectsActive} 3D Projects.`}
      >
        <span className="user-data__counter-wrapper">
          <Icon type={['far', 'handshake-alt']} className="user-data__counters-icon" notSpaced />
          <span className="heading-14">
            {totals.projectsDone}
          </span>
        </span>
      </Tooltip>
      <Tooltip
        wrapperClassName="user-data__tooltip-wrapper"
        id={`model-views__tooltip-${username}`}
        content="Model views"
      >
        <span className="user-data__counter-wrapper">
          <Icon type={['far', 'eye']} className="user-data__counters-icon" notSpaced />
          <span className="heading-14">
            {numeral(totals.modelViews).format(totals.modelViews > 1000 ? '0.0a' : '0a')}
          </span>
        </span>
      </Tooltip>
    </div>
  )
}

UserInfoStats.propTypes = {
  username: PropTypes.string.isRequired,
  totals: PropTypes.shape({
    modelCount: PropTypes.number,
    projectsDone: PropTypes.number,
    projectsActive: PropTypes.number,
    modelViews: PropTypes.number,
  }),
}

export default UserInfoStats
